"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVisitorId = exports.getVisitorId = exports.setSessionValue = exports.getSessionValue = exports.setPersistentValue = exports.getPersistentValue = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var firefly_properties_1 = require("../constants/firefly-properties");
var utilities_1 = require("../utilities");
var cookies_1 = require("./cookies");
function retrieveCookie(isPersistent) {
    var cookieValue;
    if (isPersistent) {
        cookieValue = cookies_1.get(firefly_properties_1.default.PERSISTENT_STORE, true);
    }
    else {
        cookieValue = cookies_1.get(firefly_properties_1.default.SESSION_STORE, true);
    }
    if (firefly_utilities_helper_ts_1.isNullOrUndefined(cookieValue)) {
        cookieValue = {};
    }
    return cookieValue;
}
function getPersistentValue(key) {
    var result;
    var data = cookies_1.get(firefly_properties_1.default.PERSISTENT_STORE, true);
    if (!firefly_utilities_helper_ts_1.isNullOrUndefined(data) && utilities_1.containsKey(data, key)) {
        result = data[key];
    }
    return result;
}
exports.getPersistentValue = getPersistentValue;
function setPersistentValue(key, value) {
    var cookieValue = retrieveCookie(true);
    cookieValue[key] = value;
    return cookies_1.set(firefly_properties_1.default.PERSISTENT_STORE, cookieValue, firefly_properties_1.default.EXPIRATION_DAYS);
}
exports.setPersistentValue = setPersistentValue;
function getSessionValue(key) {
    var result;
    var data = cookies_1.get(firefly_properties_1.default.SESSION_STORE, true);
    if (!firefly_utilities_helper_ts_1.isNullOrUndefined(data) && utilities_1.containsKey(data, key)) {
        result = data[key];
    }
    return result;
}
exports.getSessionValue = getSessionValue;
function setSessionValue(key, value) {
    var cookieValue = retrieveCookie(false);
    cookieValue[key] = value;
    return cookies_1.set(firefly_properties_1.default.SESSION_STORE, cookieValue, 0); //TODO:expiration
}
exports.setSessionValue = setSessionValue;
function getVisitorId() {
    return cookies_1.get(firefly_properties_1.default.VISITOR_ID, false);
}
exports.getVisitorId = getVisitorId;
function setVisitorId(value) {
    return cookies_1.set(firefly_properties_1.default.VISITOR_ID, value, firefly_properties_1.default.VID_EXPIRATION_DAYS);
}
exports.setVisitorId = setVisitorId;
